import { Box, type BoxProps, Stack, type StackProps } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { useAdminLayoutContext } from './AdminLayoutContext';
import { LinkAdmin } from './LinkAdmin';
import { ADMIN_PATH } from './constants';

export const AdminNavBarMainMenu = ({ ...rest }: StackProps) => {
  const { t } = useTranslation(['components', 'interview', 'survey']);
  return (
    <Stack direction="row" spacing="1" {...rest}>
      <AdminNavBarMainMenuItem to="/dashboard">
        {t('components:dashboard.title')}
      </AdminNavBarMainMenuItem>
      <AdminNavBarMainMenuItem to="/interviews">
        {t('interview:interviews')}
      </AdminNavBarMainMenuItem>
      <AdminNavBarMainMenuItem to="/surveys">
        {t('survey:surveys')}
      </AdminNavBarMainMenuItem>
      <AdminNavBarMainMenuItem to="/candidates">
        {t('components:layout.candidates')}
      </AdminNavBarMainMenuItem>
      <AdminNavBarMainMenuItem to="/boards">
        {t('components:board.ATSBoards')}
      </AdminNavBarMainMenuItem>
    </Stack>
  );
};

const AdminNavBarMainMenuItem = ({
  to,
  ...rest
}: BoxProps & { to: string }) => {
  const { navDrawer } = useAdminLayoutContext();
  const { pathname } = useLocation();

  const isActive =
    to === '/'
      ? pathname === (ADMIN_PATH || '/')
      : pathname.startsWith(`${ADMIN_PATH}${to}`);

  return (
    <Box
      as={LinkAdmin}
      to={to}
      color={isActive ? 'brand.500' : 'gray.600'}
      bg="transparent"
      justifyContent="flex-start"
      position="relative"
      fontWeight={isActive ? 'semibold' : 'medium'}
      borderRadius="md"
      px="4"
      py="2"
      _active={{ bg: 'gray.50' }}
      _hover={{
        bg: 'gray.100',
        textDecoration: 'none',
        _after: {
          opacity: 1,
          w: '4rem',
        },
      }}
      _focusVisible={{
        outline: 'none',
        bg: 'gray.100',
        _after: {
          opacity: 1,
          w: '2rem',
        },
      }}
      _after={{
        opacity: isActive ? 1 : 0,
        content: '""',
        position: 'absolute',
        insetStart: '50%',
        bottom: '0',
        transform: 'translateX(-50%)',
        transition: '0.2s',
        w: isActive ? 'full' : 0,
        h: '2px',
        borderRadius: 'full',
        bg: 'brand.500',
      }}
      onClick={navDrawer.onClose}
      {...rest}
    />
  );
};
